// extracted by mini-css-extract-plugin
export default {"logo":"daily-specialsktnqsZ","placeholder":"daily-specialsJksUV5","logo__image":"daily-specialsmdc-uA"};